import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiInputLabelStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            display: 'flex',
            fontFamily: variables.fonts.additional,
            transform: 'translate(12px, 9px) scale(1)',
            '[aria-label]': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            '&.Mui-focused': {
                color: variables.colors.other.inputs.focus,
            },
            '&.MuiInputLabel-shrink': {
                transform: 'translate(2px, -20px) scale(0.75)',
            },
            '&.Mui-error': {
                color: variables.colors.error.main,
            },
            '.MuiFormLabel-asterisk': {
                color: variables.colors.error.main,
                verticalAlign: 'top',
                order: '-1',
                paddingRight: '3px',
                textAlign: 'left',
                marginLeft: '-3px',
            },
            '@media print': {
                transform: 'translate(12px, -20px) scale(0.75)',
            },
        },
    },
});

export default createMuiInputLabelStyles;
